import type { CrowdexSavedAgent } from '@crowdex/agent-contracts';
import type { AssistantView } from '@crowdex/agent-contracts/api';
import { apiFetch } from '@crowdex/host-kit/renderer/http';
import { readAccountAgentProfiles } from '@/lib/agent-profiles-client';

/**
 * What the assistant dialogs read besides the directory: the saved agents, and the avatars (the
 * call plugin's personas). One module so tests replace it whole.
 */
export function fetchPersonas(): Promise<CrowdexSavedAgent[]> {
  return readAccountAgentProfiles();
}

/** The avatars an assistant may speak as: the call plugin's personas, none without one. */
export async function fetchAvatars(): Promise<{ id: string; name: string }[]> {
  const view = await apiFetch<AssistantView>('/api/assistant', { cache: 'no-store' });
  return view.personas.map((persona) => ({ id: persona.id, name: persona.title }));
}
